// src/components/support/SupportFlow.js
import React from 'react';
import ContactSection from '../contact/ContactSection';
import './SupportFlow.css';
import './MobileSupportFlow.css'; // Import mobile styles

const SupportFlow = () => {
  return (
    <section className="support-flow-section">
      {/* Main title */}
      <h2 className="support-flow-title">サポートの流れ</h2>
      
      {/* Main container for the flow items */}
      <div className="frame-48098449">
        {/* First flow item */}
        <div className="flow-item frame-158">
          {/* Desktop layout */}
          <div className="desktop-flow-content">
            <div className="frame-48098415">
              <div className="frame-48098420">
                <div className="step-contact-container">
                  <div className="frame-48098419">
                    <p className="step-text">STEP</p>
                    <p className="step-number">01</p>
                  </div>
                  <p className="contact-method">公式LINEまたはお電話でお問い合わせ</p>
                </div>
                <p className="flow-text">「自分が生活保護を受けられるのか知りたい…」そんな方は公式LINEまたはお電話で簡単にお問い合わせください！</p>
              </div>
            </div>
            <div className="image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/support_1.png'} 
                alt="問い合わせ" 
                className="flow-image"
              />
            </div>
          </div>
          
          {/* Mobile layout */}
          <div className="mobile-flow-content">
            <div className="step-contact-container">
              <div className="frame-48098419">
                <p className="step-text">STEP</p>
                <p className="step-number">01</p>
              </div>
              <p className="contact-method">公式LINEまたはお電話でお問い合わせ</p>
            </div>
            <div className="image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/support_1.png'} 
                alt="問い合わせ" 
                className="flow-image"
              />
            </div>
            <p className="flow-text">「自分が生活保護を受けられるのか知りたい…」そんな方は公式LINEまたはお電話で簡単にお問い合わせください！</p>
          </div>
          
          <div className="flow-line-container">
            <div className="line-30"></div>
            <svg className="flow-svg" xmlns="http://www.w3.org/2000/svg" width="80" height="20" viewBox="0 0 80 20" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M0 0C0 11.0457 17.9086 20 40 20C62.0914 20 80 11.0457 80 0H0Z" fill="#F4792B"/>
            </svg>
          </div>
        </div>
        
        {/* Second flow item */}
        <div className="flow-item frame-159">
          {/* Desktop layout */}
          <div className="desktop-flow-content">
            <div className="frame-48098415">
              <div className="frame-48098420">
                <div className="step-contact-container">
                  <div className="frame-48098419">
                    <p className="step-text">STEP</p>
                    <p className="step-number">02</p>
                  </div>
                  <p className="contact-method">賃貸に入居（最短当日）</p>
                </div>
                <p className="flow-text">「住む場所がなくて今すぐ困っている…」そんな方には、即日入居できる家具・家電付きの物件をご案内します！</p>
              </div>
            </div>
            <div className="image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/support_2.png'} 
                alt="賃貸入居" 
                className="flow-image"
              />
            </div>
          </div>
          
          {/* Mobile layout */}
          <div className="mobile-flow-content">
            <div className="step-contact-container">
              <div className="frame-48098419">
                <p className="step-text">STEP</p>
                <p className="step-number">02</p>
              </div>
              <p className="contact-method">賃貸に入居（最短当日）</p>
            </div>
            <div className="image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/support_2.png'} 
                alt="賃貸入居" 
                className="flow-image"
              />
            </div>
            <p className="flow-text">「住む場所がなくて今すぐ困っている…」そんな方には、即日入居できる家具・家電付きの物件をご案内します！</p>
          </div>
          
          <div className="flow-line-container">
            <div className="line-30"></div>
            <svg className="flow-svg" xmlns="http://www.w3.org/2000/svg" width="80" height="20" viewBox="0 0 80 20" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M0 0C0 11.0457 17.9086 20 40 20C62.0914 20 80 11.0457 80 0H0Z" fill="#F4792B"/>
            </svg>
          </div>
        </div>
        
        {/* Third flow item */}
        <div className="flow-item frame-160">
          {/* Desktop layout */}
          <div className="desktop-flow-content">
            <div className="frame-48098415">
              <div className="frame-48098420">
                <div className="step-contact-container">
                  <div className="frame-48098419">
                    <p className="step-text">STEP</p>
                    <p className="step-number">03</p>
                  </div>
                  <p className="contact-method">サポートを受けながら生活保護申請</p>
                </div>
                <p className="flow-text">専門のスタッフが役所まで同行し、完全サポートします！疾病・障害・高齢などの理由で本人が役所に行けない場合には、代わりに申請手続きを行うことも可能です。</p>
              </div>
            </div>
            <div className="image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/support_3.png'} 
                alt="生活保護申請サポート" 
                className="flow-image"
              />
            </div>
          </div>
          
          {/* Mobile layout */}
          <div className="mobile-flow-content">
            <div className="step-contact-container">
              <div className="frame-48098419">
                <p className="step-text">STEP</p>
                <p className="step-number">03</p>
              </div>
              <p className="contact-method">サポートを受けながら生活保護申請</p>
            </div>
            <div className="image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/support_3.png'} 
                alt="生活保護申請サポート" 
                className="flow-image"
              />
            </div>
            <p className="flow-text">専門のスタッフが役所まで同行し、完全サポートします！疾病・障害・高齢などの理由で本人が役所に行けない場合には、代わりに申請手続きを行うことも可能です。</p>
          </div>
          
          <div className="flow-line-container">
            <div className="line-30 last-line"></div>
          </div>
        </div>
      </div>
      
      {/* Contact Container - similar positioning to hero section */}
      <div className="support-contact-wrapper">
        <ContactSection />
      </div>
    </section>
  );
};

export default SupportFlow;